import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IDropdownOption } from 'src/app/core/interfaces/common/ui/dropdown-option.interface';

@Component({
  selector: 'app-kendo-dropdown',
  templateUrl: './kendo-dropdown.component.html',
  styleUrls: ['./kendo-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KendoDropdownComponent),
      multi: true,
    },
  ],
})
export class KendoDropdownComponent implements ControlValueAccessor, OnInit {
  @Input() dropdownHeaderText: string;
  @Input() defaultOption: IDropdownOption;
  @Input() options: IDropdownOption[];
  @Input() minWidthValue: string = 'min-width: 100%';
  @Output() selectionChange = new EventEmitter<any>();

  ngOnInit(): void {}

  onSelectionChange(event: any) {
    this.defaultOption = this.options.filter((x) => x.value === event.value)[0];

    this.selectionChange.emit(event);
  }
  value: string;

  onChange = (value: string) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
